import { obterConfiguracoesSistema, atualizarLgpd } from './configuracoes-sistema.service';

type LgpdListener = (ativo: boolean) => void;

const lgpdListeners = new Set<LgpdListener>();
let lgpdAtivo = false;

function emitLgpd(ativo: boolean): void {
    lgpdAtivo = ativo;
    lgpdListeners.forEach((listener) => listener(ativo));
}

export function subscribeLgpd(listener: LgpdListener): () => void {
    listener(lgpdAtivo);
    lgpdListeners.add(listener);
    return () => lgpdListeners.delete(listener);
}

export function isLgpdAtivo(): boolean {
    return lgpdAtivo;
}

export async function carregarEstadoLgpd(): Promise<void> {
    try {
        const config = await obterConfiguracoesSistema();
        emitLgpd(Boolean(config?.lgpd));
    } catch (error) {
        console.error('Erro ao carregar estado LGPD:', error);
        emitLgpd(false);
    }
}

export async function atualizarEstadoLgpd(ativo: boolean): Promise<void> {
    const resultado = await atualizarLgpd(ativo);
    if (!resultado.success) {
        throw new Error(resultado.errors.join('; ') || 'Falha ao atualizar LGPD');
    }
    emitLgpd(ativo);
}
